import React, { useEffect, useState } from "react";
import { getDayBook } from "../../../api/endpoints/allReports";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import SideBar from "../../sidebar/sideBar";
import Header from "../../header/header.jsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getSite } from "../../../api/endpoints/refrences.js";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

const DayBook = () => {
  const { access_token } = useSelector(authSelector);
  const [dateEntered, setDateEntered] = useState("");
  const [itemsQueue, setItemsQueue] = useState([]);
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();

  const setDate = (e) => {
    setDateEntered(e.target.value);
  };

  const getName = async (e) => {
    const result = await getSite(access_token);
    if (result.success) {
      setSiteName(result.data[0].Name);
      setSiteAddress(result.data[0].Address);
    } else {
      message.error(result.message);
    }
  };

 const editHandler = async () => {
    if (!dateEntered) return message.error("Please type date !");
    let data = { enteredOn: dateEntered };

    const results = await getDayBook(data, access_token);
    if (!results.success) {
      return message.error(results.message || "Error fetching data");
    }

    if (results.data.length === 0) {
      return message.error("No Record Found in this date");
    }

    const payload = results.data.map((curr) => ({
      enteredOn: curr.enteredOn,
      itemCode: curr.itemCode,
      itemName: curr.itemName,
      saleRate: Number(curr.saleRate),
      purchaseRate: Number(curr.purchaseRate),
      quantity: Number(curr.quantity),
      partyName: curr.partyName,
      partyId: Number(curr.partyId),
      generalLedgerCode: Number(curr.generalLedgerCode),
      generalLedgerDescription: curr.generalLedgerDescription,
      description: curr.description,
      purchaseVoucherNo: curr.purchaseVoucherNo,
      voucherNumber: curr.voucherNumber,
      cheqNumber: curr.cheqNumber,
      debit: curr.debit,
      credit: curr.credit,
      siteId: curr.siteId,
      printOrder: curr.printOrder,
      itemDescription: curr.itemDescription,
      meterCheck: curr.meterCheck,
    }));

    setItemsQueue(payload);
    generatePDF(payload);
  };

  useEffect(() => {
    getName();
  }, []);

  function formatDate(inputDate) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = new Date(inputDate).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  }

  const generatePDF = (data) => {
    if (!data || data.length === 0) {
      message.error("No data to generate report!");
      return;
    }

    // Landscape A4
    const doc = new jsPDF("l", "mm", "a4");

    // ====== Header ======
    doc.setFontSize(10);
    doc.text(`Day Book`, 148, 5, { align: "center" });
    doc.setFontSize(16);
    doc.text(`${siteName}`, 148, 11, { align: "center" });
    doc.setFontSize(12);
    doc.text(`${siteAddress}`, 148, 16, { align: "center" });
    doc.setFontSize(10);
    doc.text(`Date: ${formatDate(dateEntered)}`, 148, 20, { align: "center" });

    // ====== Opening Balance from printOrder = 0 ======
    const openingBalance = data
      .filter((r) => r.printOrder === 0)
      .reduce(
        (sum, r) => sum + (Number(r.credit) || 0) - (Number(r.debit) || 0),
        0
      );

    // ====== Credit side (Receipts) ======
    const creditRows = data
      .filter((r) => [1, 2, 3, 6].includes(r.printOrder) && r.credit > 0)
      .map((r) => ({
        description: r.description,
        credit: r.credit,
      }));

    // 👉 Insert Opening Balance as first row in Credit side
    if (openingBalance !== 0) {
      creditRows.unshift({
        description: "Cash In Hand B/F",
        credit: openingBalance,
      });
    }

    // ====== Debit side (Payments) ======
    const debitRows = data
      .filter((r) => [15, 17, 3, 18].includes(r.printOrder) && r.debit > 0)
      .map((r) => ({
        description: r.description,
        debit: r.debit,
      }));

    // ====== Build table row by row ======
    const maxLen = Math.max(creditRows.length, debitRows.length);
    const tableRows = [];

    for (let i = 0; i < maxLen; i++) {
      const creditDesc = creditRows[i]?.description || "";
      const creditAmt = creditRows[i]
        ? Number(creditRows[i].credit || 0).toLocaleString()
        : "";

      const debitDesc = debitRows[i]?.description || "";
      const debitAmt = debitRows[i]
        ? Number(debitRows[i].debit || 0).toLocaleString()
        : "";

      tableRows.push([creditDesc, creditAmt, debitDesc, debitAmt]);
    }

    // ====== Totals ======
    // ====== Totals ======
    const totalCredit = creditRows.reduce(
      (sum, r) => sum + (parseFloat(r.credit) || 0),
      0
    );
    const totalDebit = debitRows.reduce(
      (sum, r) => sum + (parseFloat(r.debit) || 0),
      0
    );

    // Cash in Hand = Total Credit - Total Debit
    const cashInHand = totalCredit - totalDebit;

    // Push "Cash in Hand" row before totals
    tableRows.push([
      "", // empty credit description
      "", // empty credit amount
      "Cash In Hand C/F", // debit description
      { content: cashInHand.toLocaleString(), styles: { fontStyle: "bold" } },
    ]);

    // 👉 Add cashInHand into totalDebit before displaying
    const adjustedTotalDebit = totalDebit + cashInHand;

    // Push totals row
    tableRows.push([
      { content: "Total:", styles: { fontStyle: "bold" } },
      { content: totalCredit.toLocaleString(), styles: { fontStyle: "bold" } },
      { content: "Total:", styles: { fontStyle: "bold" } },
      {
        content: adjustedTotalDebit.toLocaleString(),
        styles: { fontStyle: "bold" },
      },
    ]);

    // ====== Render AutoTable ======
    autoTable(doc, {
      head: [["Description", "Receipts", "Description", "Payments"]],
      body: tableRows,
      startY: 22,
      theme: "grid",
      margin: { left: 5, right: 5 },
      styles: {
        fontSize: 9,
        cellPadding: 1,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
        valign: "middle",
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
      },
      columnStyles: {
        0: { halign: "left", cellWidth: 105, valign: "middle" },
        1: { halign: "center", cellWidth: 30, valign: "middle" },
        2: { halign: "left", cellWidth: 110, valign: "middle" },
        3: { halign: "center", cellWidth: 35, valign: "middle" },
      },
    });

    // ====== Open PDF in new tab ======
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl);
  };

  // const generatePDF = (data) => {
  //   if (!data || data.length === 0) {
  //     message.error("No data to generate report!");
  //     return;
  //   }

  //   // Landscape A4
  //   const doc = new jsPDF("l", "mm", "a4");

  //   // Title (148 mm is center of landscape A4)
  //   doc.setFontSize(16);
  //   doc.text(`${siteName}`, 148, 11, { align: "center" });
  //   doc.setFontSize(12);
  //   doc.text(`${siteAddress}`, 148, 16, { align: "center" });
  //   doc.setFontSize(10);
  //   doc.text(`DayBook:- ${formatDate(dateEntered)}`, 148, 20, { align: "center" });

  //   // Separate Credit (Receipts) and Debit (Payments)
  //   const receiptRows = data
  //   .filter((r) => r.printOrder < 10)
  //   .sort((a, b) => a.printOrder - b.printOrder);

  // // ✅ PAYMENTS: printOrder > 10
  // const paymentRows = data
  //   .filter((r) => r.printOrder > 10)
  //   .sort((a, b) => a.printOrder - b.printOrder);

  // const maxLen = Math.max(receiptRows.length, paymentRows.length);
  // const tableRows = [];

  //  for (let i = 0; i < maxLen; i++) {
  //   tableRows.push([
  //     receiptRows[i]?.ItmName || "",
  //     receiptRows[i]?.Credit
  //       ? Number(receiptRows[i].Credit).toLocaleString()
  //       : "",
  //     paymentRows[i]?.ItmName || "",
  //     paymentRows[i]?.Debit
  //       ? Number(paymentRows[i].Debit).toLocaleString()
  //       : "",
  //   ]);
  // }

  // // Totals
  // const totalReceipt = receiptRows.reduce(
  //   (sum, r) => sum + (Number(r.Credit) || 0),
  //   0
  // );
  //   const totalPayment = paymentRows.reduce(
  //   (sum, r) => sum + (Number(r.Cebit) || 0),
  //   0
  // );

  //   tableRows.push([
  //     { content: "Total:", styles: { fontStyle: "bold" } },
  //     { content: totalReceipt.toLocaleString(), styles: { fontStyle: "bold" } },
  //     { content: "Total:", styles: { fontStyle: "bold" } },
  //     { content: totalPayment.toLocaleString(), styles: { fontStyle: "bold" } },
  //   ]);

  //   // AutoTable settings (landscape → more room for descriptions)
  //   autoTable(doc, {
  //     head: [["Description", "Receipts", "Description", "Payments"]],
  //     body: tableRows,
  //     startY: 22,
  //     theme: "grid",
  //     margin: { left: 5, right: 5 },
  //     styles: {
  //       fontSize: 9,
  //       cellPadding: 1,
  //       textColor: [0, 0, 0],
  //       lineColor: [0, 0, 0],
  //       lineWidth: 0.5,
  //       valign: "middle",
  //     },
  //     headStyles: {
  //       fillColor: [255, 255, 255],
  //       textColor: [0, 0, 0],
  //       fontStyle: "bold",
  //       halign: "center",
  //       valign: "middle",
  //       lineColor: [0, 0, 0],
  //       lineWidth: 0.5,
  //     },
  //     columnStyles: {
  //       0: { halign: "left", cellWidth: 105, valign: "middle" }, // wider
  //       1: { halign: "center", cellWidth: 35, valign: "middle" },
  //       2: { halign: "left", cellWidth: 105, valign: "middle" }, // wider
  //       3: { halign: "center", cellWidth: 35, valign: "middle" },
  //     },
  //     // columnStyles: {
  //     //   0: { halign: "left" }, // wider
  //     //   1: { halign: "center"},
  //     //   2: { halign: "left" }, // wider
  //     //   3: { halign: "center"},
  //     // },
  //   });

  //   // Open PDF in new tab
  //   const pdfBlob = doc.output("blob");
  //   const pdfUrl = URL.createObjectURL(pdfBlob);
  //   window.open(pdfUrl);
  // };
// TO Generate Report in Excel
//   const generateExcel = (data) => {
//   if (!data || data.length === 0) {
//     message.error("No data to generate Excel!");
//     return;
//   }

//   // Prepare rows same as PDF
//   const creditRows = data
//     .filter((r) => r.Credit && r.Credit !== 0)
//     .sort((a, b) => a.Type - b.Type);

//   const debitRows = data
//     .filter((r) => r.Debit && r.Debit !== 0)
//     .sort((a, b) => a.Type - b.Type);

//   const maxLen = Math.max(creditRows.length, debitRows.length);
//   const excelRows = [];

//   for (let i = 0; i < maxLen; i++) {
//     const creditDesc = creditRows[i]?.ItmName || "";
//     const creditAmt = creditRows[i]?.Credit || "";

//     const debitDesc = debitRows[i]?.ItmName || "";
//     const debitAmt = debitRows[i]?.Debit || "";

//     excelRows.push({
//       "Description (Receipts)": creditDesc,
//       "Amount (Receipts)": creditAmt,
//       "Description (Payments)": debitDesc,
//       "Amount (Payments)": debitAmt,
//     });
//   }

//   // Totals
//   const totalCredit = creditRows.reduce(
//     (sum, r) => sum + (parseFloat(r.Credit) || 0),
//     0
//   );
//   const totalDebit = debitRows.reduce(
//     (sum, r) => sum + (parseFloat(r.Debit) || 0),
//     0
//   );

//   excelRows.push({
//     "Description (Receipts)": "Total",
//     "Amount (Receipts)": totalCredit,
//     "Description (Payments)": "Total",
//     "Amount (Payments)": totalDebit,
//   });

//   // Create worksheet & workbook
//   const worksheet = XLSX.utils.json_to_sheet(excelRows);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "DayBook");

//   // Export to Excel
//   const excelBuffer = XLSX.write(workbook, {
//     bookType: "xlsx",
//     type: "array",
//   });

//   const dataBlob = new Blob([excelBuffer], {
//     type:
//       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
//   });

//   saveAs(dataBlob, "DayBook.xlsx"); // ✅ Save directly as Excel file
// };


  const clearState = () => {
    setItemsQueue([]);
    setDateEntered("");
  };

  return (
    <>
      <div className="flex bg-black main">
        <SideBar />
        <div className="h-full flex flex-col content-center w-full">
          <div className="flex justify-center mt-32">
            <div className="meterTableMain flex flex-col w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className="text-white">Day Book</h1>
              </div>
              <div className="flex flex-col h-40 items-center justify-evenly">
                <div>
                  <label className="text-white">Date:</label>
                  <input
                    type="date"
                    className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                    value={dateEntered}
                    onChange={setDate}
                  />
                </div>
                <div>
                  <button
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                    onClick={editHandler}
                  >
                    View PDF
                  </button>
                  <button
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                    onClick={clearState}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DayBook;
